"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torre-le-nocelle": {
    "d154a0de": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "skipSearch": false
    }],
    "bosco-faiano": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0626c630": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "900bfe68": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "skipSearch": false
    }],
    "cirignano": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "290058ca": [{
      "hkey": "8165de9b",
      "slug": "campoceraso",
      "name": "Campoceraso",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-campoceraso": [{
      "hkey": "8165de9b",
      "slug": "campoceraso",
      "name": "Campoceraso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f717e576": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "skipSearch": false
    }],
    "pesanti": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c53c53f3": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "skipSearch": false
    }],
    "piesco": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "883ed7f9": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "skipSearch": false
    }],
    "san-iuliano": [{
      "hkey": "79e9aaca",
      "slug": "torre-le-nocelle",
      "name": "Torre Le Nocelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;